import React, {useEffect} from 'react';
import {BrowserRouter as Router, Navigate, Route, Routes, useLocation} from 'react-router-dom';
import MainNavigation from './common/presentation/navigation/MainNavigation';
import ScrollToTop from './common/ui/scroll/ScrollToTop';
import {initializeRemoteConfig} from "./common/RemoteConfigHook";
import {CookiesProvider} from "react-cookie";
import {AdRefreshProvider} from "./common/ui/ad/AdRefreshContext";
import {MarkoComponent} from "./feature/marko/MarkoComponent";
import LandingPageComponent from "./feature/landing/LandingPageComponent";
import SupportComponent from "./feature/support/SupportComponent";

function AppContent() {
    const location = useLocation();
    const isLandingPage = location.pathname === '/';
    // Full-bleed, chrome-less routes (no top nav, no main margin)
    const isFullBleed = isLandingPage || location.pathname === '/marko' || location.pathname === '/support';

    useEffect(() => {
        initializeRemoteConfig();

        // Add/remove body class for full-bleed background override
        if (isFullBleed) {
            document.body.classList.add('landing-page-active');
        } else {
            document.body.classList.remove('landing-page-active');
        }

        // Cleanup function
        return () => {
            document.body.classList.remove('landing-page-active');
        };
    }, [isFullBleed]);

    return (
        <>
            <ScrollToTop/>
            {!isFullBleed && <MainNavigation/>}
            <main>
                <Routes>
                    <Route path="/" element={<LandingPageComponent/>}/>
                    <Route path="/marko" element={<MarkoComponent />} />
                    <Route path="/support" element={<SupportComponent />} />
                    <Route path="*" element={<Navigate to="/" replace/>}/>
                </Routes>
            </main>
        </>
    );
}

function App() {
    return (
        <CookiesProvider>
            <AdRefreshProvider>
                <Router>
                    <AppContent />
                </Router>
            </AdRefreshProvider>
        </CookiesProvider>
    );
}

export default App;
